module.exports = __webpack_public_path__ + "media/images/mailer/check-48-white-9211ca8b86f21e7843e752873f6d14ad.png";